import { Box, Flex } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/react";
import { Empty } from "antd";
import { DocumentoItem } from "core/features/documentos/typings";
import Documento from "./Documento";

interface DocumentosProps {
  documentos: DocumentoItem[] | undefined;
  isLoading: boolean;
  nomePasta: string;
  onEdit?: (id: string) => any;
  onDelete?: (id: string) => any;
}

function Documentos({
  documentos,
  isLoading,
  onEdit,
  onDelete,
}: DocumentosProps) {
  return (
    <Flex flexDir="column" gridGap={"16px"}>
      {isLoading ? (
        <>
          <Skeleton w="100%" h="90px" rounded={16} />
          <Skeleton w="100%" h="90px" rounded={16} />
          <Skeleton w="100%" h="90px" rounded={16} />
          <Skeleton w="100%" h="90px" rounded={16} />
        </>
      ) : null}

      {!isLoading && !documentos?.length ? (
        <Empty description="Essa pasta não tem nenhum documento." />
      ) : null}

      {!isLoading && documentos?.length
        ? documentos.map((d) => (
            <Box w="100%" key={d.id}>
              <Documento documento={d} onEdit={onEdit} onDelete={onDelete} />
            </Box>
          ))
        : null}
    </Flex>
  );
}

export default Documentos;
